export const getPlanDetectionState = (plan, resolvedCurrentPlanAmount) => {
  return {
    isCurrentByAmount:
      !plan.isCurrent && plan.amount === resolvedCurrentPlanAmount,
    isUpgrade: !plan.isCurrent && plan.amount > resolvedCurrentPlanAmount,
    isDowngrade: !plan.isCurrent && plan.amount < resolvedCurrentPlanAmount,
  };
};
